import styled from 'styled-components';
import { rem } from 'polished';

export const Section = styled.section`
  padding: ${rem('80px')} ${rem('16px')};
  background: #1a1a1a;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    padding: ${rem('60px')} ${rem('16px')};
  }
`;

export const GrafanaContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${rem('60px')};
  align-items: center;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    grid-template-columns: 1fr;
    gap: ${rem('40px')};
    text-align: center;
  }
`;

export const LeftContent = styled.div`
  color: white;
`;

export const RightContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    min-height: 280px;
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    min-height: 220px;
  }
`;

export const MainTitle = styled.h1`
  font-family: 'MontserratBlack', sans-serif;
  color: white;
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  line-height: 1.3;
  margin-bottom: ${rem('60px')};
  font-weight: 800;
  letter-spacing: -0.5px;
  text-align: center;
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    margin-bottom: ${rem('40px')};
  }
`;

export const MainDescription = styled.p`
  font-size: ${rem('18px')};
  color: #b3b3b3;
  line-height: 1.6;
  margin-bottom: ${rem('32px')};
  max-width: 500px;
`;

export const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const FeatureItem = styled.li`
  position: relative;
  font-size: ${rem('16px')};
  color: #d1d5db;
  line-height: 1.6;
  margin-bottom: ${rem('12px')};
  padding-left: ${rem('32px')};

  &::before {
    content: '✓';
    position: absolute;
    left: 0;
    top: 0;
    color: #fbbf24;
    font-weight: bold;
    font-size: ${rem('18px')};
  }
`;

export const AnimationWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.3s ease;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    max-width: 90%;
    margin: 0 auto;
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    max-width: 85%;
  }

  &:hover {
    transform: scale(1.05);
  }
`;
